import { render, staticRenderFns } from "./AxFilesystemViewerActionsFolder.vue?vue&type=template&id=d4345410&"
import script from "./AxFilesystemViewerActionsFolder.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemViewerActionsFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports